import { c as _c } from "react/compiler-runtime";
import { Breadcrumb, type BreadcrumbItem } from '@7f-ui/components/breadcrumb/breadcrumb';
import { dateParser } from '@feat/feat-url-state/date';
import { serializeUrlState } from '@feat/feat-url-state/schema';
import { useUrlState } from '@feat/feat-url-state/use-url-state';
import { objectKeys } from '@utils/helpers';
import { pick } from 'es-toolkit';
import { useState } from 'react';
type AppExperienceBreadcrumbsProps = {
  experience: {
    slug: string;
    title: string;
    publicId: number;
  };
  destination?: {
    slug: string;
    name: string;
  } | null;
  links?: BreadcrumbItem[];
  placement?: 'top' | 'bottom';
};
export function AppExperienceBreadcrumbs(t0) {
  const $ = _c(21);
  const {
    links: t1,
    destination,
    experience,
    placement
  } = t0;
  let t2;
  if ($[0] !== t1) {
    t2 = t1 === undefined ? [] : t1;
    $[0] = t1;
    $[1] = t2;
  } else {
    t2 = $[1];
  }
  const links = t2;
  const {
    urlState
  } = useUrlState();
  let t3;
  if ($[2] !== urlState) {
    t3 = serializeUrlState(pick(urlState, objectKeys(dateParser)));
    $[2] = urlState;
    $[3] = t3;
  } else {
    t3 = $[3];
  }
  const searchParams = t3;
  const [dateSelection] = useState(searchParams);
  let t4;
  if ($[4] === Symbol.for("react.memo_cache_sentinel")) {
    t4 = {
      url: "/reiseziele/",
      label: "Alle Reiseziele"
    };
    $[4] = t4;
  } else {
    t4 = $[4];
  }
  let breadcrumbs;
  if ($[5] !== dateSelection || $[6] !== destination || $[7] !== experience.publicId || $[8] !== experience.slug || $[9] !== experience.title || $[10] !== links) {
    breadcrumbs = [t4];
    if (destination) {
      const t5 = `/reiseziele/${destination.slug}/`;
      let t6;
      if ($[12] !== destination.name || $[13] !== t5) {
        t6 = {
          label: destination.name,
          url: t5
        };
        $[12] = destination.name;
        $[13] = t5;
        $[14] = t6;
      } else {
        t6 = $[14];
      }
      breadcrumbs.push(t6);
    }
    const t5 = `/erlebnisse/${experience.publicId}/${experience.slug}/${dateSelection}`;
    let t6;
    if ($[15] !== experience.title || $[16] !== t5) {
      t6 = {
        label: experience.title,
        url: t5,
        truncate: true
      };
      $[15] = experience.title;
      $[16] = t5;
      $[17] = t6;
    } else {
      t6 = $[17];
    }
    breadcrumbs.push(t6);
    breadcrumbs.push(...links);
    $[5] = dateSelection;
    $[6] = destination;
    $[7] = experience.publicId;
    $[8] = experience.slug;
    $[9] = experience.title;
    $[10] = links;
    $[11] = breadcrumbs;
  } else {
    breadcrumbs = $[11];
  }
  let t5;
  if ($[18] !== breadcrumbs || $[19] !== placement) {
    t5 = <Breadcrumb placement={placement} links={breadcrumbs} />;
    $[18] = breadcrumbs;
    $[19] = placement;
    $[20] = t5;
  } else {
    t5 = $[20];
  }
  return t5;
}